











import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  PriceDto,
  PriceTypeDto
} from '@eurogast/hub-client-typescript';

@Component
export default class PriceIcons extends Vue {
  @Prop({required: true})
  public currentPrice: PriceDto;

  get priceType(): PriceTypeDto {
    return this.currentPrice && this.currentPrice.type;
  }

  get isSpecialPrice(): boolean {
    return this.priceType === PriceTypeDto.SPECIAL;
  }

  get isPromotionPrice(): boolean {
    return this.priceType === PriceTypeDto.PROMOTION;
  }
}
